<section [class.sidenav]="isExpanded">
    <div class="toggle">
      <mat-icon (click)="toggleMenu.emit(null)">
        {{ isExpanded ? "keyboard_backspace" : "dehaze" }}
      </mat-icon>
    </div>
   
  </section>